// Copyright 2022, Imprivata, Inc.  All rights reserved.
import { useEffect, useState } from 'react';
import BlueHexAnimation from '../../assets/svg/blueHexAnimation.svg';
import ScriptedSvg from '../svg/ScriptedSvg';
import './Loading.less';
export const LoadingSpinner = () => {
  const [isScriptedSvgReady, setIsScriptedSvgReady] = useState(false);
  const [shouldLoadAnimated, setShouldLoadAnimated] = useState(false);
  // Start loading the animated SVG after a brief delay to ensure fallback is visible first
  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldLoadAnimated(true);
    }, 50); // Small delay to ensure fallback renders first
    return () => clearTimeout(timer);
  }, []);
  const handleSvgLoad = () => {
    setIsScriptedSvgReady(true);
  };
  const handleSvgError = (error: Error) => {
    console.error('SVG loading failed:', error);
    // Keep fallback animation running if SVG fails to load
  };
  return (
    <div className="loading-spinner-container" data-testid="loading-spinner">
      {/* Static SVG fallback - shown until animated SVG is ready */}
      {!isScriptedSvgReady && (
        <img src={BlueHexAnimation} className="loading-animation loading-fallback" alt="Loading..." />
      )}
      {/* Animated SVG - only render after delay and show when ready */}
      {shouldLoadAnimated && (
        <div
          className={`loading-svg-wrapper ${isScriptedSvgReady ? 'loading-svg-wrapper--visible' : 'loading-svg-wrapper--hidden'}`}
        >
          <ScriptedSvg
            url={BlueHexAnimation}
            className="loading-animation"
            onLoad={handleSvgLoad}
            onError={handleSvgError}
          />
        </div>
      )}
    </div>
  );
};
export default LoadingSpinner;
